export default "__VITE_ASSET__S7_yyOTn__"